import React from "react";
import "./Header.css";
import NotificationsModal from "./NotficationsModal";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@mui/material";

function Header({ pageTitle, showBackButton }) {
	const navigate = useNavigate();
	const location = useLocation();

	const handleGoBack = () => {
		const pathname = window.location.pathname;
		const pathParts = pathname.split("/");
		const patId = pathParts[pathParts.length - 2];
		pageTitle === "Discharge"
			? navigate("/profile/" + patId)
			: window.history.back();
	};

	return (
		<>
			<header className="App-header">
				<div className="headerSec p-4">
					<div className="row align-items-center">
						<div className="col">
							{showBackButton ? (
								<>
									{/* <Button
									onClick={handleGoBack}
									variant="outlined"
									startIcon={
										<FontAwesomeIcon icon={faArrowLeft} />
									}
								>
									Back
								</Button> */}
									<button
										type="button"
										className="btn btn-link px-0 text-decoration-none profile-text !text-base"
										onClick={handleGoBack}
									>
										<i className="fas fa-long-arrow-left me-1"></i>{" "}
										Back
									</button>
								</>
							) : (
								<h1 className="mb-0 header-text">
									{pageTitle}
								</h1>
							)}
							{location.pathname === "/" && (
								<div className="d-flex align-items-center">
									<i className="fas fa-plus-circle me-1 text-green"></i>
									<label className="me-2 ">
										<Link
											to={`/newPatient/page1`}
											className="text-decoration-none"
										>
											Intake patient
										</Link>
									</label>
								</div>
							)}
						</div>
						<div className="col-auto">
							<div className="d-flex gap-4 align-items-center">
								{/* <div className="flex flex-row items-center custominp bg-gray-200 rounded-lg">
									<div
										className="px-3 py-2"
										id="basic-addon1"
									>
										<i className="far fa-search"></i>
									</div>
									<input
										type="text"
										className="flex-grow pl-0 border-l-0 py-2"
										placeholder="Search..."
										aria-label="Username"
										aria-describedby="basic-addon1"
									/>
								</div> */}
								<div>
									<NotificationsModal />
								</div>
								<div className="d-flex align-items-center profileMenu col-auto">
									<div className="flex-shrink-0">
										<img
											src="/images/profile-icon.png"
											alt=""
										/>
									</div>
									<div className="flex-grow-1 ms-2 profile-name">
										Walter Pearlman
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
}

export default Header;
